import React, { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import paths from '../paths';
import { createValidatedRoute, isValidAlphanumericId } from '../../utils/helper/helper';
import { createRoute } from 'constants/utils';
const Orders = lazy(() => import('../../components/pages/order/orders/Orders'));
const Fulfilments = lazy(() => import('../../components/pages/order/fulfilments/Fulfilments'));
const Clicks = lazy(() => import('../../components/pages/order/click/Clicks'));
const Initials = lazy(() => import('../../components/pages/order/batchUpdates/UpdateInitials/UpdateInitials'));
const Upsells = lazy(() => import('../../components/pages/order/batchUpdates/UpdateUpsells/UpdateUpsells'));
const SubscriptionUpdates = lazy(() => import('../../components/pages/order/batchUpdates/UpdateSubscriptions/UpdateSubscriptions'));
const SubscriptionDetails = lazy(() => import('../../components/pages/order/subscription/Subscription'));
const AutoReruns = lazy(() => import('../../components/pages/order/batchResults/BatchResults/BatchResults'));
const Order = lazy(() => import('../../components/pages/order/orderDetails/Order'));
const Transactions = lazy(() => import('../../components/pages/order/transaction/Transactions'));
const TestOrders = lazy(() => import('../../components/pages/order/testOrders/TestOrders'));
const BatchReports = lazy(() => import('../../components/pages/order/batchResults/BatchReport/BatchReport'));

export const orderRoutes = (abilities) => {
  const routes = [
    (abilities?.order?.read ?? false) && createRoute(paths.orders, Orders),
    (abilities?.fulfillment?.read ?? false) && createRoute(paths.orderFulfilments, Fulfilments),
    (abilities?.click?.read ?? false) && createRoute(paths.clicks, Clicks),

    (abilities?.order?.read ?? false) && {
      path: paths.batchUpdates,
      children: [
        {
          index: true,
          element: (
            <Navigate
              replace
              to={paths.batchInitials}
            />
          ),
        },
        createRoute('initials', Initials),
        createRoute('upsells', Upsells),
        createRoute('subscriptions', SubscriptionUpdates),
      ],
    },
    (abilities?.auto_rerun?.read ?? false) && createRoute(paths.autoReruns, AutoReruns),
    (abilities?.auto_rerun?.read ?? false) && createRoute(paths.batchReport, BatchReports),
    (abilities?.transactions?.read ?? false) && createRoute(paths.transactions, Transactions),
    (abilities?.order?.read ?? false) && createRoute(paths.testOrders, TestOrders),
  ].filter(Boolean);

  const indexPath = routes.length > 0 ? routes[0].path : '/*';

  return [
    {
      path: paths.getOrderLayout,
      children: [
        {
          index: true,
          element: (
            <Navigate
              replace={true}
              to={indexPath}
            />
          ),
        },
      ],
    },
    ...routes,
    (abilities?.order?.read ?? false) && createValidatedRoute(paths.order(':number'), Order, isValidAlphanumericId),
    (abilities?.subscription?.read ?? false) && createValidatedRoute(paths.subscription(':number'), SubscriptionDetails, isValidAlphanumericId),
  ];
};
